import styled from "@emotion/styled";

type ActionConnectionCardTypes = {
  size: string;
  highlighted?: boolean;
};
export const AppConnectionCard = styled.div<ActionConnectionCardTypes>`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  row-gap: ${(p) => (p.size === "small" ? "0.25rem" : "0.5rem")};
  column-gap: 1rem;
  border-radius: 1rem;
  border: none;
  background: ${(p) => p.theme.colors.background};
  color: ${(p) => p.theme.text.colors.primary};
  transition: all 0.2s ease-in-out;
  padding: ${(p) => (p.size === "small" ? "0.75rem" : "1.5rem")};
  ${(p) =>
    p.highlighted &&
    `
    position: relative;
    z-index: 1001;
  `}
`;

export const AppConnectionContent = styled.div<{ size: string }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`;

export const AppConnectionLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
  min-width: 0;
`;

export const AppConnectionNameRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const AppIcon = styled.div<{ size: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${(p) => (p.size === "small" ? "1.5rem" : "2rem")};

  img {
    width: 100%;
    height: auto;
    max-width: ${(p) => (p.size === "small" ? "1.5rem" : "2rem")};
    max-height: ${(p) => (p.size === "small" ? "1.5rem" : "2rem")};
  }
`;
export const AppName = styled.div<{ size: string }>`
  font-size: ${(p) =>
    p.size === "small" ? p.theme.text.fontSizes.m : p.theme.text.fontSizes.xl};
`;
export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  flex-shrink: 0;
`;
